import { CALL_API } from "admin/middlewares/api";

export const ORIGINATOR_GET_REQUEST = "ORIGINATOR_GET_REQUEST";
export const ORIGINATOR_GET_SUCCESS = "ORIGINATOR_GET_SUCCESS";
export const ORIGINATOR_GET_ERROR = "ORIGINATOR_GET_ERROR";

export function get_originators() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/originators",
      authenticatedRequest: true,
      types: [
        ORIGINATOR_GET_REQUEST,
        ORIGINATOR_GET_SUCCESS,
        ORIGINATOR_GET_ERROR,
      ],
    },
  };
}
